import { Typography, Button } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import { IconAlertTriangle, IconRefresh } from "@tabler/icons-react";
import PreviewShell from "./PreviewShell";

interface PreviewErrorStateProps {
  onRetry?: () => void;
}

const PreviewErrorState = ({ onRetry }: PreviewErrorStateProps) => (
  <PreviewShell>
    <Stack flex="1" align="center" justify="center">
      <div className="al-text-center al-max-w-sm">
        <Stack justify="center" className="al-mb-4">
          <div className="al-p-3 al-rounded-full al-bg-red-50">
            <IconAlertTriangle className="al-h-10 al-w-10 al-text-red-400" strokeWidth={1.5} />
          </div>
        </Stack>
        <Typography variant="body" weight="medium" className="al-mb-2 al-text-gray-700">
          Unable to load preview
        </Typography>
        <Typography variant="body" size="xs" className="al-text-gray-500 al-mb-4 al-block">
          Something went wrong while generating the preview. Please try again.
        </Typography>
        {onRetry && (
          <Button variant="outline" size="sm" onClick={onRetry}>
            <IconRefresh className="al-h-4 al-w-4 al-mr-2" />
            Retry
          </Button>
        )}
      </div>
    </Stack>
  </PreviewShell>
);

export default PreviewErrorState;
